import StudentResourceTab from './student-resource-tab';

export default StudentResourceTab;
